import { useMutation, useQueryClient } from '@tanstack/react-query';
import { gqlFetcher, type MutationOptions } from '../fetcher';
import { CreateParticipantRestrictivePractice } from '../mutations/createParticipantRestrictivePractice.mutation';
import type {
  CreateParticipantRestrictivePracticeMutation,
  CreateParticipantRestrictivePracticeMutationVariables,
} from '../types';

export const useCreateParticipantRestrictivePracticeMutation = (
  options?: MutationOptions<
    CreateParticipantRestrictivePracticeMutation,
    CreateParticipantRestrictivePracticeMutationVariables
  >,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(CreateParticipantRestrictivePractice), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('participant'),
      });
    },
  });
};
